// Which sidebar entry stays highlighted while the offline screen replaces the page the user is on.
// Derived from the URL because every /a route renders the same OfflinePage (see AppRouter).
// Returns '' for pages with no sidebar entry (admin pages).
export function offlineSidebarSelection(path: string): string {
  if (path == '/a/home' || path.startsWith('/a/home/')) return 'home';
  if (path == '/a/starred') return 'starred';
  if (path == '/a/read-later') return 'read-later';
  if (path == '/a/myfeeds') return 'myfeeds';
  if (path == '/a/import') return 'import';
  if (path == '/a/preferences') return 'preferences';
  if (path == '/a/account' || path == '/a/import-opml' || path == '/a/import-feeds') return 'account';
  if (path == '/a/new' || path.startsWith('/a/new/')) return 'all-items';
  if (path == '/a/add' || path.startsWith('/a/add/')) return 'add';
  if (path == '/a/help' || path.startsWith('/a/help/')) return 'help';
  const feed = /^\/a\/(?:feed|filter)\/([^/]+)/.exec(path);
  return feed ? feed[1] : '';
}
